import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { ScrollText } from 'lucide-react'
import { AuditScreen } from '@/screens/govern/SCR-046-audit'

const day = z.string().regex(/^\d{4}-\d{2}-\d{2}$/)

export const Route = createFileRoute('/_app/govern/audit')({
  staticData: { screen: { id: 'SCR-046', title: 'Audit ledger', group: 'Govern', perm: 'audit.read', order: 2, description: 'Every action in your organisation, tamper-evident and exportable.', icon: ScrollText } },
  validateSearch: z.object({
    actor: z.string().max(200).optional().catch(undefined),
    action: z.string().max(120).optional().catch(undefined),
    object_type: z.string().max(80).optional().catch(undefined),
    object_id: z.string().max(200).optional().catch(undefined),
    workspace_id: z.string().max(200).optional().catch(undefined),
    decision: z.enum(['allowed', 'denied', 'succeeded', 'failed']).optional().catch(undefined),
    from: day.optional().catch(undefined),
    to: day.optional().catch(undefined),
    event: z.string().max(200).optional().catch(undefined),
  }),
  component: AuditScreen,
})
